import React, { useRef } from 'react';
import classnames from 'classnames';
import GlobalProps from '../../../components/globalProps';
import './LogoUploadButton.css';
import { Icon } from '../../../components/Icon/Icon';
import { t } from '../../../locales/translate';

interface Props extends GlobalProps {
  error?: boolean;
  onChange?: (e: File[]) => void;
  multiple?: boolean;
  required?: boolean;
}

export function LogoUploadButton({ multiple, onChange, className, style, required }: Props): JSX.Element {
  const fileUpload: React.MutableRefObject<HTMLInputElement | null> = useRef(null);

  function handleOnChange(fileList: FileList): void {
    if (onChange) {
      onChange(Array.from(fileList));

      if (fileUpload.current) {
        fileUpload.current.value = '';
      }
    }
  }

  return (
    <div className={classnames('product-image', className)} style={style}>
      <div
        className="logoUpload-button__wrapper"
        onClick={() => {
          fileUpload.current?.click();
        }}
      >
        <div className="logoUpload-button__icon">
          <Icon name="plus" />
        </div>
        <div>{t.actions.upload(t.model.image._plural)}</div>
      </div>
      <input
        type="file"
        ref={fileUpload}
        style={{ visibility: 'hidden' }}
        accept="image/*"
        onChange={(e) => {
          if (e.target.files) {
            handleOnChange(e.target.files);
          }
        }}
        required={required}
        multiple={multiple}
      />
    </div>
  );
}
